module.exports = __webpack_public_path__ + "static/media/agent-icon.479afbd1.svg";